/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

const prefix = (type) => `st/devices/${type}`;

export const LOAD_START = prefix('LOAD_START');
export const LOAD_SUCCESS = prefix('LOAD_SUCCESS');
export const LOAD_FAILED = prefix('LOAD_FAILED');

export const LIST_LOAD_START = prefix('LIST_LOAD_START');
export const LIST_LOAD_SUCCESS = prefix('LIST_LOAD_SUCCESS');
export const LIST_LOAD_FAILED = prefix('LIST_LOAD_FAILED');

export const GATEWAYS_LIST_LOAD_START = prefix('GATEWAYS_LIST_LOAD_START');
export const GATEWAYS_LIST_LOAD_SUCCESS = prefix('GATEWAYS_LIST_LOAD_SUCCESS');
export const GATEWAYS_LIST_LOAD_FAILED = prefix('GATEWAYS_LIST_LOAD_FAILED');

export const REPEATERS_LIST_LOAD_START = prefix('REPEATERS_LIST_LOAD_START');
export const REPEATERS_LIST_LOAD_SUCCESS = prefix('REPEATERS_LIST_LOAD_SUCCESS');
export const REPEATERS_LIST_LOAD_FAILED = prefix('REPEATERS_LIST_LOAD_FAILED');

export const AUDIO_SNIPPETS_LOAD_START = prefix('AUDIO_SNIPPETS_LOAD_START');
export const AUDIO_SNIPPETS_LOAD_SUCCESS = prefix('AUDIO_SNIPPETS_LOAD_SUCCESS');
export const AUDIO_SNIPPETS_LOAD_FAILED = prefix('AUDIO_SNIPPETS_LOAD_FAILED');

export const AUDIO_SNIPPET_URL_LOAD_START = prefix('AUDIO_SNIPPET_URL_LOAD_START');
export const AUDIO_SNIPPET_URL_LOAD_SUCCESS = prefix('AUDIO_SNIPPET_URL_LOAD_SUCCESS');
export const AUDIO_SNIPPET_URL_LOAD_FAILED = prefix('AUDIO_SNIPPET_URL_LOAD_FAILED');

export const AUDIO_SNIPPETS_CLEAR = prefix('AUDIO_SNIPPETS_CLEAR');

export const CLEAR = prefix('CLEAR');
